import {PeepRelatedPeepSortType} from 'nutshell-graphql-types';

export const SORT_OPTIONS = [
    {
        id: 'name_asc',
        value: PeepRelatedPeepSortType.NAME_ASC,
        label: 'Name (A-Z)',
    },
    {
        id: 'name_desc',
        value: PeepRelatedPeepSortType.NAME_DESC,
        label: 'Name (Z-A)',
    },
    {
        id: 'recently_added',
        value: PeepRelatedPeepSortType.CREATED_TIME_DESC,
        label: 'Recently added',
    },
    {
        id: 'default',
        value: null,
        label: 'Default',
    },
];
